'use strict';
/** family: Dropdown **/
var __assign =
	(this && this.__assign) ||
	function () {
		__assign =
			Object.assign ||
			function (t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s)
						if (Object.prototype.hasOwnProperty.call(s, p))
							t[p] = s[p];
				}
				return t;
			};
		return __assign.apply(this, arguments);
	};
var __rest =
	(this && this.__rest) ||
	function (s, e) {
		var t = {};
		for (var p in s)
			if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
				t[p] = s[p];
		if (s != null && typeof Object.getOwnPropertySymbols === 'function')
			for (
				var i = 0, p = Object.getOwnPropertySymbols(s);
				i < p.length;
				i++
			)
				if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
		return t;
	};
Object.defineProperty(exports, '__esModule', { value: true });
var classNames = require('classnames');
var React = require('react');
var trackMetric_1 = require('../../metrics/trackMetric');
var SafeAnchor_1 = require('../SafeAnchor');
var CLASS_NAME = 'i-dropdown__menu__item';
var DropdownItemRole;
(function (DropdownItemRole) {
	DropdownItemRole['MenuItem'] = 'menuitem';
	DropdownItemRole['Option'] = 'option';
})(
	(DropdownItemRole =
		exports.DropdownItemRole || (exports.DropdownItemRole = {}))
);
var DropdownItem = function (_a) {
	var active = _a.active,
		anchorRef = _a.anchorRef,
		className = _a.className,
		disabled = _a.disabled,
		divider = _a.divider,
		header = _a.header,
		readOnly = _a.readOnly,
		children = _a.children,
		onClick = _a.onClick,
		metricOptions = _a.metricOptions,
		role = _a.role,
		restProps = __rest(_a, [
			'active',
			'anchorRef',
			'className',
			'disabled',
			'divider',
			'header',
			'readOnly',
			'children',
			'onClick',
			'metricOptions',
			'role',
		]);
	if (divider) {
		return React.createElement(
			'div',
			__assign(
				{
					className: classNames(
						CLASS_NAME,
						className,
						'dropdown-divider'
					),
					ref: anchorRef,
					role: 'separator',
				},
				restProps
			)
		);
	}
	if (header) {
		return React.createElement(
			'h6',
			__assign(
				{
					className: classNames(
						CLASS_NAME,
						className,
						'dropdown-header'
					),
				},
				restProps
			),
			children
		);
	}
	if (readOnly) {
		return React.createElement(
			'div',
			__assign(
				{
					className: classNames(
						CLASS_NAME,
						className,
						'dropdown-item-text'
					),
				},
				restProps
			),
			children
		);
	}
	return (
		// role cannot be a default prop, else Dropdown context overrides will not work.
		React.createElement(
			SafeAnchor_1.SafeAnchor,
			__assign(
				{
					anchorRef: anchorRef,
					className: classNames(
						CLASS_NAME,
						'dropdown-item',
						{
							active: active,
							disabled: disabled,
						},
						className
					),
					onClick:
						!disabled &&
						trackMetric_1.trackMetric(metricOptions, onClick),
					role: role || SafeAnchor_1.SafeAnchorRole.MenuItem,
					tabIndex: -1,
				},
				restProps
			),
			children
		)
	);
};
exports.DropdownItem = DropdownItem;
DropdownItem.Role = DropdownItemRole;
//# sourceMappingURL=DropdownItem.js.map
